import { render, staticRenderFns } from "./user_permission.vue?vue&type=template&id=43507b06&scoped=true&"
import script from "./user_permission.vue?vue&type=script&lang=js&"
export * from "./user_permission.vue?vue&type=script&lang=js&"
import style0 from "./user_permission.vue?vue&type=style&index=0&id=43507b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43507b06",
  null
  
)

export default component.exports